import merge from 'lodash/merge';

import applicationConfiguration from './application-configuration';
import applicationLocalization from './application-localization';

export default applicationContext => {
    const defaults = {
        applicationId: 'admin',
        applicationName: 'Tenant Administration',
        applicationConfiguration,
        applicationLocalization,
    };

    return merge(defaults, applicationContext);
};
